import { render, staticRenderFns } from "./FreeMealEditor.vue?vue&type=template&id=67920249&"
import script from "./FreeMealEditor.vue?vue&type=script&lang=js&"
export * from "./FreeMealEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports